import { useQuery } from "react-query";

import { makeRequest } from "../../util";
import { LatestWebTrackerReportResponse } from "../types";
import { envLocker } from "../../reducers/environments";

export default function useFetchLatestReport() {
  return useQuery({
    queryKey: ["web-tracker-latest-report", envLocker.getEnvID()],
    queryFn: async () => {
      const res = await makeRequest<LatestWebTrackerReportResponse>(
        "get_latest_web_tracker_report",
        undefined,
        {
          validateStatus: (status) => status === 200 || status === 404,
        }
      );

      if (res.status === 404) {
        return undefined;
      }

      return {
        ...res.data,
        report: {
          ...res.data.report,
          startedAt: new Date(res.data.report.startedAt),
          finishedAt: new Date(res.data.report.finishedAt),
        },
        reportTrackerStats: res.data.reportTrackerStats.map((stats) => ({
          ...stats,
          firstDetectedAt: new Date(stats.firstDetectedAt),
          lastDetectedAt:
            stats.lastDetectedAt && new Date(stats.lastDetectedAt),
        })),
        trackers: res.data.trackers.map((t) => {
          const mapped = { ...t };

          if (t.resolution) {
            mapped.resolution = {
              ...t.resolution,
              updatedAt: t.resolution && new Date(t.resolution.updatedAt),
            };
          }

          if (t.baa) {
            mapped.baa = {
              ...t.baa,
              uploadedAt: t.baa && new Date(t.baa.uploadedAt),
              deletedAt: t.baa && new Date(t.baa.deletedAt),
            };
          }

          return mapped;
        }),
      };
    },
    retry: (failureCount, error: { retryable?: boolean }) => {
      if (failureCount >= 2) {
        return false;
      }
      // errors are retryable by default
      return error.retryable !== false;
    },
  });
}
